import React from 'react';
import { Popover } from 'antd';
import {
    CheckOutlined
} from '@ant-design/icons';
import {
    ColorTile,
    ColorNameSpan,
    PopoverContent,
    SectionLabel,
    PaletteRow,
    PaletteGrid,
    ColorPickerTrigger,
    ColorTileWrapper
} from './ColorPicker.styles';
import { useAppSelector } from '../../../hooks/redux';
import { Color } from '../../../redux/actions/colorsActions/types';
import { blueDark01 } from '../../../styles/colors';

interface ColorPickerProps {
    color: Color | null;
    setColor: (color: Color | null) => void;
    popoverVisible: boolean;
    setPopoverVisible: (visible: boolean) => void;
}

const renderPalette = (colors: Color[], selectedColor: Color | null, onSelect: (color: Color) => void, setPopoverVisible: (visible: boolean) => void) => (
    <PaletteRow>
        {colors.map((item, indx) => (
            <ColorTile
                key={item.id || indx}
                color={item.display}
                title={item.name}
                onClick={() => { onSelect(item); setPopoverVisible(false); }}
            >
                {selectedColor?.id === item.id && <CheckOutlined style={{ color: blueDark01 }} />}
            </ColorTile>
        ))}
    </PaletteRow>
);

const renderAdditionalPalette = (colors: Color[][], selectedColor: Color | null, onSelect: (color: Color) => void, setPopoverVisible: (visible: boolean) => void) => (
    <PaletteGrid>
        {colors.map((row) => (
            row.map((item) => (
                <ColorTile
                    key={item.id}
                    color={item.display}
                    title={item.name}
                    borderColor={item.baseColor}
                    onClick={() => { onSelect(item); setPopoverVisible(false); }}
                >
                    {selectedColor?.id === item.id && <CheckOutlined style={{ color: blueDark01 }} />}
                </ColorTile>
            ))
        ))}
    </PaletteGrid>
);

const ColorPicker: React.FC<ColorPickerProps> = ({ color, setColor, popoverVisible, setPopoverVisible }) => {
    const colorsState = useAppSelector((s) => (s as any).colorsReducer);

    const basic = (colorsState?.basicColors && colorsState.basicColors.length > 0) ? colorsState.basicColors : [];
    const additional = (colorsState?.additionalColors && colorsState.additionalColors.length > 0) ? colorsState.additionalColors : [];

    const popoverContent = (
        <PopoverContent>
            <SectionLabel>Good / Better / Best</SectionLabel>
            {renderPalette(basic, color, setColor, setPopoverVisible)}
            <SectionLabel marginTop>Additional colors</SectionLabel>
            {renderAdditionalPalette(additional, color, setColor, setPopoverVisible)}
        </PopoverContent>
    );
    return (
        <Popover
            content={popoverContent}
            trigger="click"
            open={popoverVisible}
            onOpenChange={setPopoverVisible}
        >
            <ColorPickerTrigger className={popoverVisible ? "is-active" : ""} color={color?.display}>
                <ColorTileWrapper>
                    <ColorTile color={color?.display} />
                </ColorTileWrapper>
                <ColorNameSpan>{color?.name || 'Default'}</ColorNameSpan>
            </ColorPickerTrigger>
        </Popover>
    );
};
export default ColorPicker;